import { gql } from '@apollo/client';

export const PARKING_SESSION_FIELDS = gql`
  fragment ParkingSessionFields on ParkingSession {
    countryCode
    transactionId
    startDate
    endDate
    predefinedEndDate
    sessionId
    parkingZoneUid
    parkZone {
      uid
      name
      address {
        marker
      }
      commercialZoneView {
        name
      }
      parkingMethods {
        anpr
        manualStop
      }
      locationType
    }
    accessDevice {
      value
      equipmentType
    }
    customerSegment {
      uid
    }
    priceConfig {
      serviceFee {
        amount
        percent
        maxAmount
      }
    }
    price {
      totalAmount
      breakdown {
        parkingFee {
          amount
        }
        serviceFee {
          amount
        }
      }
    }
    customerGroupUid
    type
    paymentState
    paymentType
    cardId
    changelog {
      created
      from {
        accessDevice {
          value
        }
      }
      to {
        accessDevice {
          value
        }
      }
    }
    reassignments {
      reassignmentsLeft
      waitingHours
    }
    poolingInfo {
      poolingGroupUid
      pooled
      customerGroupUid
      poolParkingType
      b2bCustomerUid
    }
    tariffName
    permitAllocations {
      permitId
      permitApplies
      from
      to
      type
    }
    parkingAllowedUntil
    corporateAccountUid
  }
`;
